import { useMemo } from 'react';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useIndicatorChart = (title) => {
    const { chartData } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            chartData?.indicators.find((indicator) => {
                return indicator.type === title;
            }),
        [chartData, title]
    );

    return {
        value: series?.percentage ? Number(series.percentage) : 0
    };
};

export default useIndicatorChart;
